import { apiConfig } from '../../config';
import { fetchdata } from 'apis/FetchData';
import { handle420 } from 'apis/HandleError';

export function getTwoHopSettings(advanced) {
  const auth = window.__APP_AUTH;
  let url = apiConfig.commissionServiceGetTwoHopSettings;
  if (advanced) {
    url += '?advanced=true';
  }  
  const headers = {
    Accept: '*application/json*',
    'cache-control': 'no-cache',
    Authorization: 'Bearer ' + auth.accessToken,
    'Content-Type': 'application/json'
  };

  return fetchdata(url, { headers, method: 'GET' })
    .then((result) => {
      return result;
    })
    .catch((e) => {
      switch (e.message) {
        case '420':
          handle420();
          break;
        default:
          throw e;
      }
    });
}
